import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import SidebarSection from 'components/Shared/Sidebar/SidebarSection/Index'
import SidebarLink from 'components/Shared/Sidebar/SidebarLink/Index'
import SidebarText from 'components/Shared/Sidebar/SidebarText/Index'

const SidebarTicketExternalIdSection = ({ externalId, externalTicketLink }) => {
  const { t } = useTranslation()

  return (
    <SidebarSection title={t('ticketPage.sidebarSectionTicketId')} copyText={externalId}>
      {externalTicketLink
        ? (
          <SidebarLink
            text={externalId}
            linkTo={{ pathname: externalTicketLink }}
            target='_blank'
          />
          )
        : <SidebarText text={externalId || ''} />
      }
    </SidebarSection>
  )
}

SidebarTicketExternalIdSection.propTypes = {
  externalId: PropTypes.string,
  externalTicketLink: PropTypes.string,
}

export default SidebarTicketExternalIdSection
